window.addEventListener('turbo:load', function () {
  const disableOnClickLinks = document.querySelectorAll('[data-disable-on-click="true"]');
  disableOnClickLinks.forEach((link) => {
    if (link.dataset.disableOnClickBound === 'true') return;

    link.dataset.disableOnClickBound = 'true';
    link.addEventListener('click', function (event) {
      if (link.dataset.disabled === 'true') {
        event.preventDefault();
        return false;
      }

      link.dataset.disabled = 'true';
      link.dataset.loading = 'true';
      return true;
    });
  });

  if (
    location.href.split('/').slice(-1) == 'properties' ||
    location.href.split('/').slice(-1) == 'syncs'
  ) {
    const syncButtons = document.getElementsByClassName('fa-sync');

    for (let i = 0; i < syncButtons.length; i++) {
      syncButtons[i].addEventListener('click', function () {
        localStorage.setItem('data-redirected-after-sync-start', 'true');
      });
    }
  }

  const failureRate = document.querySelector('.failure-rate');
  const failedIntegrationsBreakdown = document.querySelector('.failed-integrations-breakdown');

  if (failureRate) {
    const failureRateNumber = parseFloat(failureRate.innerHTML);

    if (failureRateNumber < 2) {
      failureRate.classList.add('failure-rate-green');
      failedIntegrationsBreakdown?.classList.add('failure-rate-green-bg');
    } else if (failureRateNumber >= 2 && failureRateNumber <= 5) {
      failureRate.classList.add('failure-rate-orange');
      failedIntegrationsBreakdown?.classList.add('failure-rate-orange-bg');
    } else {
      failureRate.classList.add('failure-rate-red');
      failedIntegrationsBreakdown?.classList.add('failure-rate-red-bg');
    }
  }
});
